import { request } from '@/utils/request';

/**
 * 辅助或者通用相关api
 */
/**
 * 获取当前用户有权限的全部产品
 * @param params
 * @param payload
 * @returns
 */
export const _getAllProducts = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/getAllProducts', params, payload);
};

export const _getAllUser = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/getAllUser', params, payload);
};
export const _getUserListOfDataAuth = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/getUserListOfDataAuth', params, payload);
};
/**
 * 获取单个产品下的服务器列表
 *
 */
export const _getAllServersOfGame = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/getAllServersOfGame', params, payload);
};

/**
 * 字段模板相关接口
 */
export const _fieldTemplateSet = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes/fieldTemplate/set', params, payload);
};
export const _fieldTemplateGetAll = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes//fieldTemplate/getAll', params, payload);
};
export const _fieldTemplateDelete = (params?: any, payload?: Request.IPayload) => {
  return request('/hermes//fieldTemplate/delete', params, payload);
};
